/**
 * @fileoverview added by tsickle
 * Generated from: models/worker-metrics-classification.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { model } from '../util/model';
/**
 * @record
 */
export function MetricsClassification() { }
if (false) {
    /** @type {?} */
    MetricsClassification.prototype.fulfilment;
    /** @type {?} */
    MetricsClassification.prototype.rating;
    /** @type {?} */
    MetricsClassification.prototype.reliability;
    /** @type {?} */
    MetricsClassification.prototype.utilisation;
    /** @type {?} */
    MetricsClassification.prototype.visitCount;
}
/** @type {?} */
export var metricsClassification = model.extend({
    modelName: 'metricsClassification'
});
